import { createSafeCaster } from '@athena-lib/safeCaster';

const alignmentOptions = ['left', 'center', 'right'] as const satisfies Array<string>;
export type Alignment = (typeof alignmentOptions)[number];
export const castAlignment = createSafeCaster(alignmentOptions);

const verticalAlignmentOptions = ['top', 'middle', 'bottom'] as const satisfies Array<string>;
export type VerticalAlignment = (typeof verticalAlignmentOptions)[number];
export const castVerticalAlignment = createSafeCaster(verticalAlignmentOptions);

export const alignClasses: Record<'desktop' | 'mobile', Record<Alignment, string>> = {
  desktop: {
    left: 'md:text-left md:items-start',
    center: 'md:text-center md:items-center',
    right: 'md:text-right md:items-end',
  },
  mobile: {
    left: 'text-left items-start',
    center: 'text-center items-center',
    right: 'text-right items-end',
  },
};

export const containerAlignClasses: Record<'desktop' | 'mobile', Record<Alignment, string>> = {
  desktop: {
    left: 'md:justify-start',
    center: 'md:justify-center',
    right: 'md:justify-end',
  },
  mobile: {
    left: 'justify-start',
    center: 'justify-center',
    right: 'justify-end',
  },
};

export const tabPageSectionClass = 'tab-page-section';

export const onTrustPilotClick = (event: Event) => {
  const tabPageSection = document.querySelector(`.${tabPageSectionClass}`);
  if (tabPageSection) {
    event.preventDefault();
    tabPageSection.scrollIntoView({ behavior: 'smooth' });
    return false;
  }
};
